/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplateInstanceIconPickerContainer as TemplateInstanceIconPicker } from './TemplateInstanceIconPicker.container';
